import { render } from "./publishing.vue?vue&type=template&id=9aaad938"
import script from "./publishing.vue?vue&type=script&lang=js"
export * from "./publishing.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__